import React from "react";
import {
    Button,
    CircularProgress,
    createStyles,
    Theme,
    WithStyles,
    withStyles
} from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";

type LoaderButtonProps = ButtonProps &
    WithStyles<typeof styles> & {
        loading?: boolean;
        text?: string;
    };

const styles = (_theme: Theme) =>
    createStyles({
        circularLoader: {
            left: "50%",
            marginLeft: -12,
            marginTop: -12,
            position: "absolute",
            top: "50%"
        },
        wrapper: {
            display: "inline-block",
            position: "relative",
            width: "fit-content"
        }
    });

class LoaderButton extends React.PureComponent<LoaderButtonProps, {}> {
    public render() {
        const classes = this.props.classes;
        const loaderColor =
            this.props.color === "primary" ? "secondary" : "primary";

        const buttonProps = {
            ...this.props,
            loading: undefined
        } as Partial<LoaderButtonProps>;
        delete buttonProps.classes;

        return (
            <div className={classes.wrapper}>
                <Button {...buttonProps}>
                    {this.props.text || this.props.children}
                </Button>
                {this.props.loading && (
                    <CircularProgress
                        size={24}
                        color={loaderColor}
                        className={classes.circularLoader}
                    />
                )}
            </div>
        );
    }
}

export default withStyles(styles)(LoaderButton);
